import { render, staticRenderFns } from "./DeviceAttrs.vue?vue&type=template&id=492dcbdc&scoped=true"
import script from "./DeviceAttrs.vue?vue&type=script&lang=js"
export * from "./DeviceAttrs.vue?vue&type=script&lang=js"
import style0 from "./DeviceAttrs.vue?vue&type=style&index=0&id=492dcbdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492dcbdc",
  null
  
)

export default component.exports